module.exports = __webpack_public_path__ + "img/petstairs42.1dd96660.jpg";